import { getMenuItemLabel } from '../config/menuStructure';

const PATH_PAGES = [
  { test: (p) => p === '/' || p === '', pageId: 'home', label: 'Home' },
  { test: (p) => p.startsWith('/hse'), pageId: 'hse', label: 'HSE' },
  { test: (p) => p.startsWith('/estimation'), pageId: 'estimation', label: 'Estimation' },
  { test: (p) => p.startsWith('/sales'), pageId: 'sales', label: 'Sales' },
  { test: (p) => p.startsWith('/training'), pageId: 'training', label: 'Training' },
  { test: (p) => p.startsWith('/processes'), pageId: 'processes', label: 'Processes' },
  { test: (p) => p.startsWith('/development'), pageId: 'development', label: 'Development' },
  { test: (p) => p.startsWith('/subcontractor-discovery'), pageId: 'subcontractor-discovery', label: 'Subcontractor Discovery' },
  { test: (p) => p.startsWith('/download-app'), pageId: 'download-app', label: 'Download App' },
  { test: (p) => p.startsWith('/quality'), pageId: 'quality', label: 'Quality' },
  { test: (p) => p.startsWith('/contractors'), pageId: 'procurement-selected-contractors', label: 'Contractors' },
  { test: (p) => p.startsWith('/resource-management'), pageId: 'resources-management', label: 'Indirect Resources' },
  { test: (p) => p.startsWith('/fabrication-histogram'), pageId: 'resources-fabrication', label: 'Corporation Resource Histogram' },
  { test: (p) => p.startsWith('/portfolio-evm'), pageId: 'resources-portfolio-evm', label: 'Portfolio EVM' },
  { test: (p) => p.startsWith('/resources'), pageId: 'resources-management', label: 'Indirect Resources' },
  { test: (p) => p.startsWith('/actuals') || p.startsWith('/time-tracker'), pageId: 'actuals', label: 'Time Tracker' },
  { test: (p) => p.startsWith('/hiring-layoff'), pageId: 'hiring-layoff', label: 'Hiring / Layoff' },
  { test: (p) => p.startsWith('/coding-structure'), pageId: 'coding-structure', label: 'Coding Structure' },
  { test: (p) => p.startsWith('/material-management'), pageId: 'material-management', label: 'Material Management' },
  { test: (p) => p.startsWith('/admin'), pageId: 'admin', label: 'Admin' },
];

const MODULE_BY_PREFIX = [
  [/^progress|piping|mechanical|electrical|structural|hvac|civil|ducts|tank|matrix/i, 'Progress Tracking'],
  [/^forecasting|billing|maestro/i, 'Forecasting'],
  [/^estimation|cost-breakdown|mto|sov|unit-rate|part-rate/i, 'Estimation'],
  [/^procurement|contractor|material-management|purchasing/i, 'Procurement'],
  [/^actuals|hiring-layoff|coding-structure|time-tracker|employees/i, 'Accounting / Time'],
  [/^schedule|gantt|ga-/i, 'Schedule'],
  [/^technical|rfi|transmittal|daily-report|sheets/i, 'Technical'],
  [/^safety|hse/i, 'HSE'],
  [/^quality|qa-qc|wps|welding/i, 'Quality'],
  [/^sales|bid-log|clients/i, 'Sales'],
  [/^pmo|roadmap|development|training|processes|portal-usage/i, 'PMO'],
  [/^admin|user-provision/i, 'Admin'],
  [/^resource/i, 'Resources'],
  [/^change|ccr/i, 'Change Management'],
];

export function moduleFromPageId(pageId) {
  const id = String(pageId || '');
  for (const [re, label] of MODULE_BY_PREFIX) {
    if (re.test(id)) return label;
  }
  return 'Other';
}

export function resolvePortalPage({ pathname, search, state, hash, projectMenuItem } = {}) {
  const menuFromQuery = (() => {
    try {
      return new URLSearchParams(search || '').get('menu');
    } catch {
      return null;
    }
  })();
  const hashMenu = hash && hash.startsWith('#') ? hash.slice(1) : (hash || null);
  const pageId = projectMenuItem || state?.menuItem || menuFromQuery || hashMenu || null;

  if (pageId) {
    return {
      pageId,
      pageLabel: getMenuItemLabel(pageId) || pageId,
      module: moduleFromPageId(pageId),
      path: pathname || '',
    };
  }

  const path = pathname || '';
  const match = PATH_PAGES.find((row) => row.test(path));
  if (match) {
    return {
      pageId: match.pageId,
      pageLabel: match.label,
      module: moduleFromPageId(match.pageId),
      path,
    };
  }

  if (path.startsWith('/project/')) {
    return {
      pageId: 'project',
      pageLabel: 'Project',
      module: 'Progress Tracking',
      path,
    };
  }

  return null;
}
